/**
 * Normalize WeldIQ / axios errors into a user-facing message.
 */
export function extractWeldiqApiError(error: unknown): string | null {
  if (error == null) return null;

  if (typeof error === 'string' && error.trim()) {
    return error.trim();
  }

  if (typeof error === 'object') {
    const e = error as {
      response?: { data?: { error?: string; message?: string }; status?: number };
      error?: string;
      message?: string;
      code?: string;
    };

    const fromBody = e.response?.data?.error || e.response?.data?.message;
    if (fromBody && String(fromBody).trim()) {
      return String(fromBody).trim();
    }

    if (e.error && String(e.error).trim()) {
      return String(e.error).trim();
    }

    const status = e.response?.status;
    if (status === 401) {
      return 'Authentication failed — sign in again or refresh your session.';
    }
    if (status === 403) {
      return 'You do not have permission to run this WeldIQ check.';
    }
    if (status === 503) {
      return 'WeldIQ scoring service is temporarily unavailable.';
    }
    if (status === 504 || e.code === 'ECONNABORTED') {
      return 'Live scoring timed out waiting for the database. Try Refresh once — repeated retries can make this worse.';
    }

    if (e.message === 'Network Error') {
      return 'Live scoring failed to reach WeldIQ (often a gateway timeout). Try Refresh once.';
    }

    if (e.message && String(e.message).trim() && e.message !== 'Network Error') {
      return String(e.message).trim();
    }
  }

  return null;
}
